import { useCallback, useMemo } from 'react';
import {
  SelectLabelOptionsQuery,
  useSelectLabelOptionsLazyQuery
} from 'graphql/types';

export interface SelectLabelSearchParams {
  id: string;
  query?: string;
}

export interface UseSelectLabelSearchResultProps {
  searchHandler: (searchParams: SelectLabelSearchParams) => void;
  data: SelectLabelOptionsQuery | undefined;
  loading: boolean;
}

export const useSelectLabelSearch = (): UseSelectLabelSearchResultProps => {
  const [getLabelOptions, { data, loading }] = useSelectLabelOptionsLazyQuery();

  const searchHandler = useCallback(
    ({ id, query }: SelectLabelSearchParams) => {
      const variables = {
        id,
        input: {
          query
        }
      };

      getLabelOptions({ variables });
    },
    [getLabelOptions]
  );

  return useMemo(
    () => ({
      searchHandler,
      data,
      loading
    }),
    [data, loading, searchHandler]
  );
};
